export const POSTS_LOADED = "POSTS_LOADED";
export const ADD_POST = "ADD_POST";
export const DELETE_POST = "DELETE_POST";
export const CHECK_NEW_POSTS = "CHECK_NEW_POSTS";



// WEBPACK FOOTER //
// ./src/redux/Posts/constants.js